import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IBreadcrumb } from '../models/breadcrumb.interface';

@Injectable({
  providedIn: 'root'
})
export class EcaBreadcrumbService {
  breadCrumbs: BehaviorSubject<IBreadcrumb[]> = new BehaviorSubject<IBreadcrumb[]>([{} as IBreadcrumb]);
  constructor() {
  }
}
